import { createAsyncTypes, createTypes } from '../utils/create-types';

export const ns = 'app';

export const actionTypes = createTypes(
  [
    'appMount',
    'hardGoTo',
    'hideCodeAlly',
    'openSignoutModal',
    'closeSignoutModal',
    'openModalGoToUnlockPage',
    'closeModalGoToUnlockPage',
    'onlineStatusChange',
    'serverStatusChange',
    'resetUserData',
    'tryToShowCodeAlly',
    'executeGA',
    'showCodeAlly',
    'submitComplete',
    'updateComplete',
    'updateFailed',
    'updateUserToken',
    'postChargeProcessing',
    'updateAllChallengesInfo',
    'changeTourStatus',
    'createMessage',
    'updateMessage',
    'deleteMessage',
    'fetchMessages',
    'startLoading',
    'stopLoading',
    'openEmailDrawer',
    'closeEmailDrawer',
    'setLoadingRecurringEmails',
    'setLoadingChangePassword',
    'openEditUserDrawer',
    'closeEditUserDrawer',
    'fetchProducts',
    'setProducts',
    'updateLinkedProduct',
    'syncProducts',
    'setLoadingProducts',
    'setLoadingSyncProducts',
    'openUnlockModuleModal',
    'closeUnlockModuleModal',
    'updateSuperBlockUnlockModuleModal',
    'addUserAiAssistantSessions',
    'updateNationalUser',
    `setCurrentTheme`,
    ...createAsyncTypes('fetchUser'),
    ...createAsyncTypes('postCharge'),
    ...createAsyncTypes('fetchProfileForUser'),
    ...createAsyncTypes('acceptTerms'),
    ...createAsyncTypes('showCert'),
    ...createAsyncTypes('reportUser'),
    ...createAsyncTypes('deleteUserToken'),
    ...createAsyncTypes('saveChallenge'),
    ...createAsyncTypes('signInLocal'),
    ...createAsyncTypes('signUpLocal'),
    ...createAsyncTypes('forgotPassword'),
    ...createAsyncTypes('recoveryPassword'),
    ...createAsyncTypes('changePassword'),
    ...createAsyncTypes('createPassword'),
    ...createAsyncTypes('verificationEmail'),
    ...createAsyncTypes('submitSubscription'),
    ...createAsyncTypes('verifyPayment'),
    ...createAsyncTypes('updatePaymentUser'),
    ...createAsyncTypes('updateAccessUtm'),
    ...createAsyncTypes('fetchMessages'),
    ...createAsyncTypes('fetchMessagesForAdmin'),
    ...createAsyncTypes('createMessage'),
    ...createAsyncTypes('updateMessage'),
    ...createAsyncTypes('deleteMessage'),
    ...createAsyncTypes('uploadImage'),
    ...createAsyncTypes('checkUserInactivityByEmail'),
    ...createAsyncTypes('unlockUserAccount'),
    ...createAsyncTypes('fetchAutomaticEmails'),
    ...createAsyncTypes('toggleActiveAutomaticEmail'),
    ...createAsyncTypes('editAutomaticEmail'),
    ...createAsyncTypes('fetchManualEmails'),
    ...createAsyncTypes('fetchRecurringEmails'),
    ...createAsyncTypes('createManualEmail'),
    ...createAsyncTypes('editManualEmail'),
    ...createAsyncTypes('cancelManualEmail'),
    ...createAsyncTypes('createRecurringEmail'),
    ...createAsyncTypes('editRecurringEmail'),
    ...createAsyncTypes('toggleActiveRecurringEmail'),
    ...createAsyncTypes('registerQuizUser'),
    ...createAsyncTypes('updateQuizUserResult'),
    ...createAsyncTypes('toggleReceiveEmails'),
    ...createAsyncTypes('createNewUserFromQuiz'),
    ...createAsyncTypes('fetchAllUsers'),
    ...createAsyncTypes('fetchAllPreEnrolled'),
    ...createAsyncTypes('fetchEditUser'),
    ...createAsyncTypes('fetchRequestToDeleteUsers'),
    ...createAsyncTypes('fetchDeletedUsers'),
    ...createAsyncTypes('getCep'),
    ...createAsyncTypes('getCityByState'),
    ...createAsyncTypes('createNewNationalUser'),
    ...createAsyncTypes('fetchAllClassGroups'),
    ...createAsyncTypes('fetchClassGroupUsers'),
    ...createAsyncTypes('newClassGroup'),
    ...createAsyncTypes('editClassGroup'),
    ...createAsyncTypes('removeClassGroup'),
    ...createAsyncTypes('moveUsersBetweenClassGroups'),
    ...createAsyncTypes('completeNacionalRegister'),
    ...createAsyncTypes('fetchAllGroups'),
    ...createAsyncTypes('getPlacementTestQuestions'),
    ...createAsyncTypes('postPlacementTestCorrection'),
    ...createAsyncTypes('postSendWelcomeMundoTechEmail'),
    ...createAsyncTypes('fetchWaitingList'),
    ...createAsyncTypes('fetchReprovedAndDropoutList'),
    ...createAsyncTypes('fetchConfirmedList'),
    ...createAsyncTypes('fetchWaitingToConfirmList'),
    ...createAsyncTypes('fetchExportWaitingList'),
    ...createAsyncTypes('fetchExportWaitingToConfirmList'),
    ...createAsyncTypes('fetchExportConfirmedList'),
    ...createAsyncTypes('fetchExportReprovedAndDropoutList'),
    ...createAsyncTypes('fetchEmailStats'),
    ...createAsyncTypes('fetchEmailSentQuantity'),
    ...createAsyncTypes('updateEmailStats'),
    ...createAsyncTypes('fetchEmailLogs'),
    ...createAsyncTypes('exportEmailLogs'),
    ...createAsyncTypes('fetchUserSilent'),
    ...createAsyncTypes('fetchAllFAQs'),
    ...createAsyncTypes('fetchPublicFAQs'),
    ...createAsyncTypes('createFAQ'),
    ...createAsyncTypes('updateFAQ'),
    ...createAsyncTypes('removeFAQ'),
    ...createAsyncTypes('updateFAQOrder'),
    ...createAsyncTypes('fetchDiscordUser'),
    ...createAsyncTypes('fetchDiscordLogs'),
    ...createAsyncTypes('fetchDiscordLogHistory'),
    ...createAsyncTypes('exportDiscordLogs'),
    ...createAsyncTypes('fetchDiscordRole'),
    ...createAsyncTypes('enrollStudent'),
    ...createAsyncTypes('markDropout'),
    ...createAsyncTypes('fetchEnrollmentAuditLogs'),
    ...createAsyncTypes('fetchClassGroupsByGroup')
  ],
  ns
);
